import { render, staticRenderFns } from "./JornadaDeExtensao.vue?vue&type=template&id=55194d28&scoped=true&lang=pug&"
import script from "./JornadaDeExtensao.vue?vue&type=script&lang=js&"
export * from "./JornadaDeExtensao.vue?vue&type=script&lang=js&"
import style0 from "./JornadaDeExtensao.styl?vue&type=style&index=0&id=55194d28&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55194d28",
  null
  
)

export default component.exports